export enum SurveyRoutes {
  Index = '/:lang/:surveySlug',
  AutoDetectLanguage = '/:surveySlug',

  participant = '/:lang/:surveySlug/participant',
  affiliate = '/:lang/:surveySlug/participant/affiliate',
  admin = '/:lang/:surveySlug/admin',
  documentGroup = '/:lang/:surveySlug/participant/survey-document-groups/:id',
  infoDocumentGroup = '/:lang/:surveySlug/participant/survey-document-groups-informational/:id',
  login = '/:lang/:surveySlug/login',
  CodeLogin = '/:lang/:surveySlug/code',
  ResetPassword = '/:lang/:surveySlug/reset-pw/:token/:email/:role',
  TwoFALogin = '/:lang/:surveySlug/2fa-login',
  TwoFASetup = '/:lang/:surveySlug/2fa-setup',
  EmailNotVVerified = '/:lang/:surveySlug/email-not-verified',
  FirstLogon = '/:lang/:surveySlug/participant/first-logon',
  FirstLogonValidation = '/:lang/:surveySlug/participant/first-logon/:userId?/:expires?/:signature?',

  AdminMailVerification = '/:lang/:surveySlug/admin/email-verification/:userId/:expires/:signature/:token',

  AdminFirstLogonValidation = '/:lang/:surveySlug/admin/first-logon/:userId?/:expires?/:signature?',
  AdminFirstLogon = '/:lang/:surveySlug/admin/first-logon',
  documentPdfViewer = '/:lang/:surveySlug/participant/survey-document-groups/:id/:documentId',

  // PARTICIPANT ROUTES
  ParticipantMailVerification = '/:lang/:surveySlug/participant/email-verification/:userId?/:expires?/:signature?/:token',

  ADMIN_ALL = '/:lang/:surveySlug/admin/*',

  // SETUP ROUTES
  setupDocumentGroups = '/:lang/:surveySlug/admin/setup/survey-document-groups',
  setupDocumentContentTextWizard = '/:lang/:surveySlug/admin/setup/survey-document-groups/:id/:document/content-text-wizard',
  setupDocumentContentTextWizardStep = '/:lang/:surveySlug/admin/setup/survey-document-groups/:id/:document/content-text-wizard/:step',
  AdminSetupSurvey = '/:lang/:surveySlug/admin/setup/survey',
  AdminSetupUsers = '/:lang/:surveySlug/admin/setup/users',
  AdminSetupExport = '/:lang/:surveySlug/admin/setup/export',
  AdminSetupParticipantGroups = '/:lang/:surveySlug/admin/setup/participant-groups',
  AdminOfflineSubmission = '/:lang/:surveySlug/admin/offline-submission',
  AdminSetupEmailTemplates = '/:lang/:surveySlug/admin/setup/survey-email-templates',
  AdminSupport = '/:lang/:surveySlug/admin/support',
  AdminLogin = '/:lang/:surveySlug/admin/login',
  AdminParticipantGropupTags = '/:lang/:surveySlug/admin/participant-group-tags',
  AdminSetupSurveyDocumentGroupsNew = '/:lang/:surveySlug/admin/setup/survey-document-groups/new',
  AdminSetupSurveyDocumentGroupEdit = '/:lang/:surveySlug/admin/setup/survey-document-groups/:id',
  AdminSetupSurveyPhaseOverview = '/:lang/:surveySlug/admin/setup/phases',

  // REPORTING ROUTES
  AdminReportingFeedbackEvaluationGroups = '/:lang/:surveySlug/admin/reporting/survey-document-feedback-evaluation-groups',
  AdminReportingSurveyMap = '/:lang/:surveySlug/admin/reporting/survey-document-maps',
  AdminReportingSurveyQuestions = '/:lang/:surveySlug/admin/reporting/survey-document-questions',
  AdminReportingSurveyModule = '/:lang/:surveySlug/admin/reporting/survey-document-survey-module',
  AdminReportingIdeaBoard = '/:lang/:surveySlug/admin/reporting/idea-board',


  SSOLoginProviders = '/:lang/:surveySlug/participant/sso-login-providers',
  Support = '/:lang/:surveySlug/support',
  ParticipantSupport = '/:lang/:surveySlug/participant/support',
  ParticipantSubmit = '/:lang/:surveySlug/participant/submit',
  SurveyDocumentPage = '/:lang/:surveySlug/participant/survey-documents/:documentId/pages/:page'
}